import React from 'react';
import ImageGallerarabicacademy from '../components/ImageGallerarabicacademy';
// import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCarabic = () => {
  const { stats, loading } = useStats();

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <div className="activity-intro">
            <h2>OUR ACTIVITIES</h2>
            <p>
              All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
            </p>
          </div>

          <ImageGallerarabicacademy />

          {/* IRC Arabic Academy */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC ARABIC ACADEMY (IAA)</h3>
            </div>
            <div className="activity-content">
              <p>
                IRC runs IRC Arabic Academy for boys and girls. The aim of this academy is to inculcate in our new generation authentic Aqeedah, Aamaal, love for the Sunnah & etiquette of Islamic life through Islamic studies and other beneficial activities.
              </p>
              <p><strong>SYLLABUS:</strong> Qaida, Nazera Quran, Tajweed, Quran Memorization, Hadith Memorization, Azkaar, Dua-e-Masoora, Akhlaqiyat, Namaz & Wudu Practice, Urdu Language, Urdu Speech, Islamic Knowledge.</p>
              <p><strong>FACILITIES:</strong> Experienced Teachers, Biometric Attendance System, Progress Report, Examination Followed with Result, Certification after Completion of Qaida/ Nazera Quran/Tajweed, Parents & Teacher Meeting, Limited Students with Teachers, CCTV Cameras, For Boys & Girls.</p>

              <div className="clinic-card">
              <h4>Branch-1: Rauza Bagh</h4>

                <p><strong>Name:</strong> IRC Arabic Academy</p>
                <p><strong>Date of Inauguration:</strong> 08-June-2022</p>
                <p><strong>Student Capacity:</strong> {formatNumber(stats.arabic_student_capacity)} (till {formatDisplayDate(stats.arabic_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('80-5506-5506')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    80-5506-5506
                  </span>
                </p>
                <p><strong>Address:</strong> Plot No. 03/9, Crescent Housing Society, Rauza Bagh Rd, Near Naval Tata Stadium, N-12, Cidco, Chhatrapati Sambhajinagar (Aurangabad) - 431003</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Website:</strong> <a href="http://www.ircarabicacademy.com" target="_blank" rel="noopener noreferrer">www.ircarabicacademy.com</a></p>
              </div>
            </div>


            <div className="activity-content">

              <div className="clinic-card">
              <h4>Branch-2: Rohila Gali</h4>

                <p><strong>Name:</strong> IRC Arabic Academy</p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>Student Capacity:</strong> {formatNumber(stats.arabic_student_capacity)} (till {formatDisplayDate(stats.arabic_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('80-5507-5507')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    80-5507-5507
                  </span>
                </p>
                <p><strong>Address:</strong> 1-23-94 Rohila Gali Aurangabad – 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Website:</strong> <a href="http://www.ircarabicacademy.com" target="_blank" rel="noopener noreferrer">www.ircarabicacademy.com</a></p>
              </div>
            </div>
            {/* <IRCTVDonationCard
              title="IRC ARABIC ACADEMY (IAA)"
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: IRC ARABIC ACADEMY (IAA)"
            /> */}
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCarabic;